<template>
   <div>
        <div>
            <v-form
               ref="create_media"
               v-model="valid_create_media"
            >
               <div class="grid gap-3">

                  <!-- IMMAGINI -->
                  <div>
                     <registration-title :title="$t('Foto')">
                        {{$t('carica_le_tue_immagini')}} ({{ $t('non_obbligatori_create') }})
                     </registration-title>
                     <upload-files
                        id="8252"
                        :convertHeic="true"
                        :format="format_imgs"
                        :p_filelist="filelist_imgs"
                        :multiple="true"
                        @fileListChange="imgsChange"
                     >
                        <span>
                           {{$t('Rilascia le immagini qui o')}} <br>
                           <b>{{$t('seleziona un’immagine')}}</b> <br>
                           <small class="text-[#808080]">({{format_imgs.extension}})</small>
                           <small class="block text-[#808080]">{{$t('max_15mb_o_128mb')}}</small>
                        </span>
                        <template v-slot:error>
                           <div v-if="error_size_imgs" class="text-red flex flex-col items-center">
                              <p>{{$t('error_max_15mb_o_128mb')}}</p>
                              <a class="text-red" @click="filelist_imgs = []">{{$t('Reset')}}</a>
                           </div>
                        </template>
                     </upload-files>
                     <div v-if="filelist_imgs && filelist_imgs.length" class="grid md:grid-cols-2 lg:grid-cols-3 gap-2 my-2" :class="{ 'opacity-0 h-0': !showimg }">
                        <div v-for="(img,index) in filelist_imgs" :key="index">
                           <div class="flex flex-col items-end">
                              <a
                                 class="text-red"
                                 @click="filelist_imgs.splice(index, 1);"
                              >{{$t('Elimina')}}</a>
                              <div class="flex justify-center w-[100%] border border-grey">
                                 <img v-if="!renderHeic" class="h-[200px]" :src="createUrl(img)" />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <!-- DOCUMENTI -->
                  <div class="mt-2">
                     <registration-title :title="$t('Curriculum')">
                        {{$t('carica_il_tuo_cv')}} ({{ $t('non_obbligatori_create') }})
                     </registration-title>
                     <upload-files
                        id="741"
                        :format="format_docs"
                        :p_filelist="filelist_docs"
                        @fileListChange="docsChange"
                     >
                        <span>
                           {{$t('Rilascia il documento qui o ')}}<br>
                           <b>{{$t('seleziona un documento')}}</b> <br>
                           <small class="text-[#808080]">({{format_docs.extension}})</small>
                           <small class="block text-[#808080]">{{$t('Massimo 15Mb')}}</small>
                        </span>
                        <template v-slot:error>
                           <div v-if="error_size_docs" class="text-red flex flex-col items-center">
                              <p>{{$t('errore_superato_15Mb')}}</p>
                              <a class="text-red" @click="filelist_docs = []">{{$t('Reset')}}</a>
                           </div>
                        </template>
                     </upload-files>
                     <div v-if="filelist_docs && filelist_docs.length" class="grid grid-cols gap-1 my-2">
                        <div v-for="(doc,index) in filelist_docs" :key="index">

                           <div class="flex items-center gap-1 ">
                              <a class="flex gap-1" :href="createUrl(doc)" target="_blank">
                                 <span>{{ getDocName(doc.name) }}</span>
                                 <v-icon color="primary">mdi-link-box-variant</v-icon>
                              </a>
                              <v-icon color="red" @click="filelist_docs.splice(index, 1)">mdi-delete</v-icon>
                           </div>
                        </div>
                     </div>
                  </div>

                  <!-- VIDEO -->
                  <div class="mt-2">
                     <registration-title :title="$t('Video')">
                        {{$t('carica_i_tuoi_video')}} ({{ $t('non_obbligatori_create') }})
                     </registration-title>
                     <upload-files
                        id="963"
                        :format="format_videos"
                        :p_filelist="filelist_videos"
                        :multiple="false"
                        @fileListChange="videosChange"
                     >
                        <span>
                           {{$t('Rilascia il video qui o')}} <br>
                           <b>{{$t('seleziona un video')}}</b> <br>
                           <small class="text-[#808080]">({{format_videos.extension}})</small>
                           <small class="block text-[#808080]">{{$t('max_30mb')}}</small>
                        </span>
                        <template v-slot:error>
                           <div v-if="error_size_videos" class="text-red flex flex-col items-center">
                              <p>{{$t('error_max_30mb')}}</p>
                              <a class="text-red" @click="filelist_videos = []">{{$t('Reset')}}</a>
                           </div>
                        </template>
                     </upload-files>
                     <transition :name="'opa'" mode="out-in">
                        <div v-if="filelist_videos && filelist_videos.length && reload_video" class="grid md:grid-cols-2 lg:grid-cols-3 gap-2 my-2">
                           <div v-for="(video,index) in filelist_videos" :key="index">

                              <div class="flex flex-col items-end">
                                 <a
                                    class="text-red"
                                    @click="filelist_videos.splice(index, 1);"
                                 >{{$t('Elimina')}}</a>
                                 <video width="100%" height="100%" controls >
                                    <source :src="createUrl(video)">
                                 </video>
                              </div>
                              
                           </div>
                        </div>
                     </transition>
                  </div>

               </div>

               <div class="flex flex-col md:flex-row gap-3 md:justify-between md:items-end mt-5 pt-1 border-t border-[#e5e7eb]">
                  <!-- <a color="#808080" @click="logout">Logout</a> -->
                  <v-btn color="grey" dark :loading="btn_loading" @click="$emit('nextStep',5)">{{$t('Indietro')}}</v-btn>
                  <v-btn
                     color="primary"
                     dark
                     :loading="btn_loading"
                     @click="nextStep()"
                     :disabled="error_size_imgs || error_size_videos || error_size_docs"
                  >{{$t('Concludi creazione profilo')}}</v-btn>
               </div>
            </v-form>
        </div>
   </div>
</template>

<script>
// import moment from "moment";
import heic2any from "heic2any";
import UploadFiles from "@/components/UploadFiles.vue";

export default {
   components: {
      UploadFiles,
   },
    data() {
      return {
         btn_loading: false,
         disable_rules: true,
         valid_create_media: true,

         reload_video: true,
         showimg: true,
         renderHeic: false,

         filelist_imgs: [],
         filelist_videos: [],
         filelist_docs: [],

         format_imgs: {
            extension: ".jpeg,.jpg,.png,.webp,.heic,.heif",
            format: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/heic', 'image/heif'],
         },
         format_videos: {
            extension: ".mp4,.mov,.wmv",
            format: ['video/mp4', 'video/quicktime', 'video/x-ms-wmv']
         },
         format_docs: {
            extension: ".pdf,.odt,.odp,.doc,.docx,.pps,.ppsx,.ppt,.pptx,.txt,.png,.jpg,.jpeg,.heic,.heif,webp",
            format: [
               'application/pdf',
               'application/vnd.oasis.opendocument.text',
               'application/vnd.oasis.opendocument.presentation',
               'application/msword',
               'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
               'application/vnd.ms-powerpoint',
               'application/vnd.openxmlformats-officedocument.presentationml.presentation',
               'text/plain',
               'image/png',
               'image/jpeg',
               'image/heic',
               'image/heif',
               'image/webp'
            ],
         },

         error_size_imgs: false,
         size_total_imgs: 0,
         error_size_videos: false,
         size_total_videos: 0,
         error_size_docs: false,
         size_total_docs: 0,
      };
   },
   computed: {
      user() {
         let _user = this.$store.getters['user/user']
         return _user
      },
   },
   watch: {
      async filelist_videos() {
         this.reload_video = false
         await this.delay(10)
         this.reload_video = true

         this.size_total_videos = 0
         this.error_size_videos = false
         this.filelist_videos.forEach(file => {
            if(file.size > 15000000){
               this.error_size_videos = true
            }
            this.size_total_videos += file.size
         });
         if(this.size_total_videos > 128000000){
            this.error_size_videos = true
         }
      },
      async filelist_imgs(){
         // che il singolo gile non superi i 15mb e che la somma dei file non superi i 128mb
         this.showimg = false
         this.size_total_imgs = 0
         this.error_size_imgs = false
         this.filelist_imgs.forEach(file => {
            if(file.size > 15000000){
               this.error_size_imgs = true
            }
            this.size_total_imgs += file.size
         });
         if(this.size_total_imgs > 128000000){
            this.error_size_imgs = true
         }

         await this.delay(1000)
         this.renderHeic = true
         await this.delay(100)
         this.renderHeic = false
         this.showimg = true

      },
      filelist_docs(){
         // che il singolo gile non superi i 15mb e che la somma dei file non superi i 128mb
         this.size_total_docs = 0
         this.error_size_docs = false
         this.filelist_docs.forEach(file => {
            if(file.size > 15000000){
               this.error_size_docs = true
            }
            this.size_total_docs += file.size
         });
         if(this.size_total_docs > 128000000){
            this.error_size_docs = true
         }
      }
   },
   methods: {
      showHeic(file){

         let t = heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.5,
            preserveExif: true,
         }).then((blob) => {
            let _file = new File([blob], file.name + ".jpeg", {type: "image/jpeg"})
            return _file
         })
         return t
      },
      imgsChange(new_filelist){
         this.filelist_imgs = new_filelist
         
      },
      videosChange(new_filelist){
         this.filelist_videos = new_filelist.slice(-1)
      },
      docsChange(new_filelist){
         this.filelist_docs = []
         if(new_filelist && new_filelist.length)
            this.filelist_docs.push(new_filelist[0])
      },

      /* ------ */
      async nextStep(){
         this.disable_rules =  false
         await this.delay(200)
         let valid = await this.$refs.create_media.validate();
         if(valid){
            this.sendEdit()
         }
      },
      async sendEdit(){
         this.btn_loading = true
         let body = {
            registrazioneCompletata: 7,
            profiloPromosso: 0
         }

         let formdata_img = new FormData();
         formdata_img.append("type", "casting/foto");
         this.filelist_imgs.forEach((file,index) => {
            formdata_img.append("file"+(index ? index+1 : ''), file, file.name);
         })

         let filelist_videos = new FormData();
         filelist_videos.append("type", "casting/video");
         this.filelist_videos.forEach((file,index) => {
            filelist_videos.append("file"+(index ? index+1 : ''), file, file.name);
         })

         let filelist_docs = new FormData();
         filelist_docs.append("type", "casting/cv");


         // this.filelist_docs.forEach(async (file,index) => {

         if(this.filelist_docs.length){
            let file = this.filelist_docs.length ? this.filelist_docs[0] : null

            if(file && (file.type == "image/heic" || file.type == "image/heif")){
               let fi = await heic2any({
                  blob: file,
                  toType: "image/jpeg",
                  quality: 0.5,
                  preserveExif: true,
               }).then((blob) => {
                  let _file = new File([blob], file.name + ".jpeg", {type: "image/jpeg"})
                  return _file
               })                  
               filelist_docs.append("file", fi, file.name + ".jpeg");
            } else {
               filelist_docs.append("file", file, file.name)
            }
         }

         let par = {
            formdata_img: formdata_img,
            filelist_videos: filelist_videos,
            filelist_docs: filelist_docs
         }

         await this.$store.dispatch('user/concludeCreateUser',par)

         if(!this.user.email){
               this.btn_loading = false
               return
         }

         let body_email = {
               type: "confirmemail",
               email: this.user.email
         }
         await this.$store.dispatch("sendMail",body_email)
         this.btn_loading = false

         await this.$store.dispatch("user/editUser",body)
         this.btn_loading = false

         window.location.reload()
      },
   },
};
</script>

<style lang="scss" scoped>
/*  */
</style>
